/*
    Пример использования debounce:

    const debounceScroll = debounce(() => {
        do stuff...
    }, 100);

    App.W.on('scroll', () => {
        debounceScroll();
    });
*/

export function debounce(func, wait, immediate) {
    let timeout;

    return function() {
        let context = this, args = arguments;
        let later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}




/*
    Пример использования throttle:

    function throttleScroll() {
        do stuff...
    }

    App.W.on('scroll', throttle(throttleScroll, 100));
*/

export function throttle(callable, wait) {
    let id;

    function call(context, list) {
        requestAnimationFrame(function() {
            callable.apply(context, list);
            id = 0;
        });
    }

    return function() {
        if (id) return;
        id = setTimeout(call, wait, this, arguments);
    };
}




/*
 Получаем координаты элемента относительно документа
 */
export function getCoords(elemDom) { // кроме IE8-
    const box = elemDom.getBoundingClientRect();

    return {
        top: box.top + pageYOffset,
        left: box.left + pageXOffset
    };
}





// WEBPACK FOOTER //
// ./_src/common/js/Util.js